export const USER_LOAD = 'user/load';
export const USER_SET = 'user/set';
export const USER_SET_LOADING_ERROR = 'user/set-loading-error';

